/**
 * The mileage of the vehicle at the time the service order was created or processed.
 * German: "Kilometerstand"
 */
export type MileageUnit = 'km' | 'miles';

export class ServiceOrderMileage {
  /** Unit of the mileage value. */
  unit: MileageUnit;

  /** The mileage value. */
  value: number;
}
